import { ManagementComponent } from '../management.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-productsdataimport',
  templateUrl: './productsdataimport.component.html',
  styleUrls: ['./productsdataimport.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class ProductsdataimportComponent implements OnInit {

  constructor(public parent: ManagementComponent, private managementService:ManagementServiceService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) {
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

      // Debounce search.
      this.warehouseSearchTermUpdate.pipe(
        debounceTime(200),
        distinctUntilChanged())
        .subscribe(value => {
          if(value?.length >= 1){
            this.GetWarehousesFiltered(value);
          }
        });

      // Debounce search.
     this.partnerSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.Filter.SearchTerm = value;
          this.GetPartnersFiltered();
        }
      });

     // Debounce search.
     this.brandSearchTermUpdate.pipe(
      debounceTime(200),
      distinctUntilChanged())
      .subscribe(value => {
        if(value?.length >= 1){
          this.GetBrandsFiltered(value);
        }
      });

     // Debounce search.
     this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {

        if(value?.length >= 1){
          this.SearchTerm = value;
          this.GetImportConfigurations();
        }
      });
   }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  searchTermUpdate = new Subject<string>();
  brandSearchTermUpdate = new Subject<string>();
  partnerSearchTermUpdate = new Subject<string>();
  warehouseSearchTermUpdate = new Subject<string>();
  SearchTerm:string;

  WarehouseFilter: {[k: string]: any} = {};
  Warehouses:any[];
  Warehouse:any;

  Filter: {[k: string]: any} = {};
  Totals: any[];
  activeFilters:{[k: string]: any} = [];
  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());

  SearchedProducts:any[];
  Products:any[];
  ShowFilter:boolean;

  Companies:any[];
  ProductBoxStatuses:any[];
  ProductConditionStatuses:any[];
  ProductManufacturingStatuses:any[];
  ProductVersionStatuses:any[];
  Countries:any[];
  WeightMeasurementTypes:any[];
  LeadTimeTypes:any[];
  ConfigurationPositions:any[];
  SellPriceCalculationTypes:any[];
  DecimalPrecisions:any[];

  NewProduct: any;
  ShowAddNewProductForm:boolean;

  BrandFilter: {[k: string]: any} = {};
  Brands:any[]; 

  Partners:any[];

  Configuration:any;
  ConfigurationName:string;

  ngOnInit(): void {
    this.InitializeFilter();
    this.InitializeBrandFilter();
    this.InitializeWarehouseFilter();
    this.GetMasterData();
    this.GetImportConfigurations();
    this.GetImportConfigurationPositions();
  }

   InitializeBrandFilter(){
    this.BrandFilter = {};
    this.BrandFilter.SearchTerm = "";
    this.BrandFilter.Pager = {};
    this.BrandFilter.Pager.PageIndex = 1;
    this.BrandFilter.Pager.PageSize = 10;
    this.BrandFilter.Pager.TotalCount = 0;
  }

  ClearSearchWarehouse(){

    if(this.Configuration != null){
      this.Configuration.Warehouse = {};
    }

    this.Filter.Partner = null;
    this.Partners = [];
    this.Warehouses = [];
   }

   InitializeWarehouses(){
    if(this.Warehouses == null || this.Warehouses.length == 0){
      this.GetWarehousesFiltered("", 1);
    }
  }

  InitializeWarehouseFilter(){
    this.WarehouseFilter = {};
    this.WarehouseFilter.SearchTerm = "";
    this.WarehouseFilter.Pager = {};
    this.WarehouseFilter.Pager.PageIndex = 1;
    this.WarehouseFilter.Pager.PageSize = 50;
    this.WarehouseFilter.Pager.TotalCount = 0;
  }

  GetMasterData(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.parent.loading = true;
 
  this.managementService.GetIndustryProductsMasterData(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Companies = response["Companies"];
      this.ProductBoxStatuses = response["ProductBoxStatuses"];
      this.ProductConditionStatuses = response["ProductConditionStatuses"];
      this.ProductManufacturingStatuses = response["ProductManufacturingStatuses"];
      this.ProductVersionStatuses = response["ProductVersionStatuses"];
      this.Countries = response["Countries"];
      this.WeightMeasurementTypes = response["WeightMeasurementTypes"];
      this.LeadTimeTypes = response["LeadTimeTypes"];
      this.SellPriceCalculationTypes = response["SellPriceCalculationTypes"];
      this.DecimalPrecisions = response["DecimalPrecisions"];
      
    }
 
    this.parent.loading = false;
   });
   }

   GetImportConfigurationPositions(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.parent.loading = true;
 
  this.managementService.GetImportConfigurationPositions(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ConfigurationPositions = response["ConfigurationPositions"];
    }

    this.parent.loading = false;
   });
   }

   comparePosition(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
  }

   FilterBrandName:string;

  InitializeFilter(){

    this.Filter = {};
    this.Filter.SearchTerm = "";

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.Company = {};
    this.Filter.Company = null;

    this.Filter.Brand = {};
    this.Filter.Brand = null;

    this.Filter.ProductBoxStatus = {};
    this.Filter.ProductBoxStatus = null;

    this.Filter.ProductConditionStatus = {};
    this.Filter.ProductConditionStatus = null;

    this.Filter.ProductManufacturingStatus = {};
    this.Filter.ProductManufacturingStatus = null;

    this.Filter.ProductVersionStatus = {};
    this.Filter.ProductVersionStatus = null;

    this.Filter.Creator = {};
    this.Filter.Creator = null;

    this.Filter.Updater = {};
    this.Filter.Updater = null;
  }

  CloseOverlay(){
    this.ShowFilter = false;
    this.SearchTerm = "";
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
    this.Filter.Period = null;
  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.activeFilters = this.activeFilters.filter(x => x.Type != "Period");
  }

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };
    
    if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
      this.ShowFilter = false;
      this.GetIndustryProductsFiltered();
    }

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);

    if(filterType == "Period"){
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "Company"){
      this.Filter.Company = null;
    }
    else if(filterType == "ProductBoxStatus"){
      this.Filter.ProductBoxStatus = null;
    }
    else if(filterType == "ProductConditionStatus"){
      this.Filter.ProductConditionStatus = null;
    }
    else if(filterType == "ProductManufacturingStatus"){
      this.Filter.ProductManufacturingStatus = null;
    }
    else if(filterType == "Period"){
      this.Filter.Period = null;
    }
    else if(filterType == "ProductVersionStatus"){
      this.Filter.ProductVersionStatus = null;
    }
    else if(filterType == "Brand"){
      this.Filter.Brand = null;
      this.FilterBrandName = "";
    }

    this.GetIndustryProductsFiltered();
  }

  OpenNewProduct(){
    // this.ShowAddNewProductForm = true;
    // this.NewProduct = {};
    // this.NewProduct.Name = "";
    // this.NewProduct.PartNumber = "";
    // this.NewProduct.Brand = {};

    // this.NewProduct.Creator = this.parent.User;
    // this.NewProduct.Updater = this.parent.User;
    this.InitializeNewIndustryProduct();
  }

  InitializeNewIndustryProduct(p:any = null, copy:boolean = false){
    
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.BrandFilter,
        Product:p,
        CopyProduct:copy
      };

      this.parent.loading = true;

      this.managementService.InitializeNewIndustryProduct(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.NewProduct = response["Product"];
          this.ShowAddNewProductForm = true;
        }

        this.parent.loading = false;
       });
   }

  GetBrandsFiltered(searchTerm:string, page = 1){
    
    this.BrandFilter.Pager.PageIndex = page;
    this.BrandFilter.SearchTerm = searchTerm;
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.BrandFilter
      };

      this.managementService.GetBrandsFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Brands = response["Brands"];
    
         if(this.Brands.length == 1){
          this.NewProduct.Brand = JSON.parse(JSON.stringify(this.Brands[0]));
          this.Brands = [];
          this.BrandFilter.SearchTerm = "";
         }
        }
       });
   }

   InitializeBrands(){
    if(this.Brands == null || this.Brands.length == 0){
      this.GetBrandsFiltered("", 1);
    }
  }

  InitializePartners(){
    if(this.Partners == null || this.Partners.length == 0){
      this.Filter.Pager.PageIndex = 1;
      this.Filter.SearchTerm = "";
      this.GetPartnersFiltered();
    }
  }

   ClearSearchBrand(){

    if(this.NewProduct != null){
      this.NewProduct.Brand = {};
    }

    this.Filter.Brand = null;
    this.Brands = [];
    this.FilterBrandName = null;
   }

   ClearPartnerBrand(){

    if(this.Configuration != null){
      this.Configuration.Partner = {};
    }

    this.Filter.Partner = null;
    this.Partners = [];
   }

 GetIndustryProductsFiltered(page = 1){
  
  this.Filter.Pager.PageIndex = page;
 
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    this.parent.loading = true;

    this.managementService.GetIndustryProductsFiltered(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Products = response["Products"];
      }

      this.parent.loading = false;
     });
 }

DeleteIndustryProduct(){
  
var request = {
  User:this.parent.User,
  Language:this.parent.getLanguage(),
  ProductID:this.NewProduct.ID,
  StatsID:this.NewProduct.Stats.ID
};

this.parent.loading = true;

this.managementService.DeleteIndustryProduct(request).subscribe(response => {

  if(response["Status"] != 1){
    this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
  }
  else if(response["Status"] == 1){
    this.Products = this.Products.filter(x => x.ID != this.NewProduct.ID);
  }

  this.parent.loading = false;
 });
}

GetImportConfigurations(){
  
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchTerm:this.SearchTerm
  };
  
  this.parent.loading = true;
  
  this.managementService.GetImportConfigurations(request).subscribe(response => {
  
    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ImportConfigurations = response["ImportConfigurations"];
    }
  
    this.parent.loading = false;
   });
  }

  InitializeImportConfigurations(){
    if(this.ImportConfigurations == null || this.ImportConfigurations.length == 0){
      this.GetImportConfigurations();
    }
  }

  //config
  ImportConfigurations:any[];
  showAddNewConfiguration:boolean;

  InitializeNewConfiguration(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.managementService.InitializeNewConfiguration(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Configuration = response["ImportConfiguration"];
        this.showAddNewConfiguration = true;
      }

      this.parent.loading = false;
     });
  }

  GetPartnersFiltered(){
    var request = {
      SearchTerm:this.Filter.SearchTerm,
      CountryID:this.Filter.Country?.ID,
      PageIndex:this.Filter.Pager.PageIndex,
      PageSize:this.Filter.Pager?.PageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.Filter.Company?.ID
    };

    this.parent.loading = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Partners = response["Partners"];
       this.Filter.Pager.TotalCount = response["Count"];
      }
   
      this.parent.loading = false;
    });
  }

  GetImportConfigurationDetails(c:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:c.ID
    };

    this.parent.loading = true;
    this.managementService.GetImportConfigurationDetails(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Configuration = response["Configuration"];
       this.SearchTerm = "";
       this.GetConfigurationOffersCOUNT(c.ID);
      }
   
      this.parent.loading = false;
    });
  }

  loadingCount:boolean = false;

  GetConfigurationOffersCOUNT(ConfigurationID:any){
      var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ConfigurationID:ConfigurationID
    };

    this.loadingCount = true;
    this.managementService.GetConfigurationOffersCOUNT(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var pager = response["Pager"];
        this.Configuration.TotalDBOffers = pager.TotalCount;
      }
   
      this.loadingCount = false;
    });
  }

  AddUpdateImportConfiguration(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Configuration:this.Configuration
    };

    this.parent.loading = true;
    this.managementService.AddUpdateImportConfiguration(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
       this.Configuration = response["Configuration"];
       this.showAddNewConfiguration = false;
      }
   
      this.parent.loading = false;
    });
  }

  ShowDeleteConfigurationOffers:boolean;

  OpenDeleteConfigurationOffers(){
    this.ShowDeleteConfigurationOffers = true;
  }

  DeleteImportConfigurationOffers(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ConfigurationID:this.Configuration.ID
    };

    this.parent.loading = true;
    this.managementService.DeleteImportConfigurationOffers(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
   
      this.parent.loading = false;
    });
  }

  ShowUpdateGroupDiscountsData:boolean;

  OpenUpdateGroupDiscountsData(){
    this.ShowUpdateGroupDiscountsData = true;
  }

  UpdateGroupDiscountsData(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Configuration:this.Configuration
    };

    this.parent.loading = true;
    this.managementService.UpdateGroupDiscountsData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
   
      this.parent.loading = false;
    });
  }

  selectedFile: File = null;

  onSelectFile(fileInput: any) {
    this.selectedFile = <File>fileInput.target.files[0];
  }

  AskImportQuestionPopUp:boolean = false;
  AskOfferingImportQuestionPopUp:boolean = false;

  CloseImportOverlay(){
    this.AskImportQuestionPopUp = false;
    this.AskOfferingImportQuestionPopUp = false;
  }

  AskImportQuestion(){
    this.AskImportQuestionPopUp = true;
  }

  AskOfferingImportQuestion(){
    this.AskOfferingImportQuestionPopUp = true;
  }

  GetProductsFromConfiguration(){
    const request = new FormData();
    request.append('User.Id', JSON.stringify(this.parent.User.Id));
    request.append('Language', this.parent.getLanguage());
    request.append('UploadedFile', this.selectedFile);
    request.append('ConfigurationID', this.Configuration.ID);
    request.append('AssignedCompanyID', this.parent.Company.ID);
    // request.append('UseParallelism', "false");
  
    this.parent.loading = true;
  
    this.managementService.GetProductsFromConfiguration(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 5000000);
      }
      else if(response["Status"] == 1){
        this.Products = response["Products"];
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 5000000);
      }
  
      this.parent.loading = false;
    });
  }
  
  DeletePreviousData:boolean = false;
  UseParallelism:boolean = true;

  GetProductsOfferingData(){
    const request = new FormData();
    request.append('User.Id', JSON.stringify(this.parent.User.Id));
    request.append('Language', this.parent.getLanguage());
    request.append('UploadedFile', this.selectedFile);
    request.append('UseParallelism', this.UseParallelism.toString());
    request.append('ConfigurationID', this.Configuration.ID);
    request.append('AssignedCompanyID', this.parent.Company.ID);
    request.append('DeletePreviousData', this.DeletePreviousData.toString());
    // request.append('UseParallelism', "false");
  
    this.parent.loading = true;
  
    this.managementService.GetProductsOfferingData(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 5000000);
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 5000000);
      }
  
      this.parent.loading = false;
    });
  }

  getOptionText(){
    return this.Configuration?.LeadTimeType?.Name;
  }

  GetWarehousesFiltered(searchTerm:string, page = 1){
    
    this.WarehouseFilter.Pager.PageIndex = page;
    this.WarehouseFilter.SearchTerm = searchTerm;
   
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        Filter:this.WarehouseFilter
      };

      this.service.GetWarehousesFiltered(request).subscribe(response => {
 
        if(response["Status"] != 1){
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Warehouses = response["Warehouses"];
    
         if(this.Warehouses.length == 1){
          this.Warehouse = JSON.parse(JSON.stringify(this.Warehouses[0]));
          this.Warehouses = [];
          this.WarehouseFilter.SearchTerm = "";
         }
        }
       });
   }

   InitializeNewDiscountGroup(){

    var group = {
      ID:0,
      UIID:this.parent.newGuid(),
      ConfigurationID:this.Configuration.ID,
      GroupName:"",
      DiscountValue:null
    };

    this.Configuration.DiscountedGroups.push(group);
   }

   CurrentDiscountGroup:any;
   ShowDiscountGroupDelete:boolean = false;

   OpenDiscountGroupDeleteQuestion(g:any){
    this.ShowDiscountGroupDelete = true;
    this.CurrentDiscountGroup = g;
   }

   RemoveDiscountGroup(g:any){

    var discountedGroups = [];
    discountedGroups.push(g);

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      DiscountedGroups:discountedGroups
    };

    this.managementService.DeleteImportConfigurationDiscountGroups(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Configuration.DiscountedGroups = this.Configuration.DiscountedGroups.filter(x => x.ID != g.ID);
      }
     });

    
   }

   UpdateConfigurationPricesAndMOQ(config:any){
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ConfigurationID:config.ID,
    };

    this.parent.loading = true;

    this.managementService.UpdateConfigurationPricesAndMOQ(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 5000000);
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 5000000);
      }

      this.parent.loading = true;
     });
   }

   CopyConfiguration(){
      this.Configuration.ID = 0;
      this.Configuration.Name = "";
   }

   ImportIndustryProductsToElastic(config:any){
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ConfigurationID:config.ID,
    };

    this.parent.loading = true;

    this.managementService.ImportIndustryProductsToElastic(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 5000000);
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 5000000);
      }

      this.parent.loading = true;
     });
   }

   ImportIndustryProductsLiteDB(config:any){
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ConfigurationID:config.ID,
    };

    this.parent.loading = true;

    this.managementService.ImportIndustryProductsLiteDB(request).subscribe(response => {

      if(response["Status"] != 1){
       this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 5000000);
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 5000000);
      }

      this.parent.loading = true;
     });
   }

   
}
